import ValueObject from "../../../../../frontend/ValueObject";
import {PricingPrice} from "./PricingPrice";

export interface IAvailabilityPrices {
    average: PricingPrice,
    lowest: PricingPrice,
}

export class AvailabilityPrices extends ValueObject<IAvailabilityPrices> {

    get average(): PricingPrice {
        return this._props.average;
    }

    get lowest(): PricingPrice {
        return this._props.lowest;
    }

    static create( priceObject: any ): AvailabilityPrices {
        const pricePayload : any = {
            lowest : new PricingPrice( {
                amount   : priceObject.lowest.amount,
                currency : priceObject.lowest.currency
            } ),
        }

        if ( priceObject.average ) {
            pricePayload.average = new PricingPrice( {
                amount   : priceObject.average.amount,
                currency : priceObject.average.currency
            } );
        }

        return new AvailabilityPrices( pricePayload );
    }
}
